export const REF_NAME = 'PACKING';
export const REF_PATH = 'packing';
export const NAME = 'Packing';
